export default __webpack_public_path__ + "static/media/one.7b1cc041.jpg";